import {ssrLazy} from 'ssr/lazy';

export const InPageNavigationInitLazy = ssrLazy(() => import(/* webpackChunkName: "inPageNavigation" */ '.'));
